import { createStyles, type Theme } from '@material-ui/core/styles';

const readerStyles_ = (theme: Theme) =>
  createStyles({
    // the page is the only scrolling surface; the reader no longer caps height
    content: { minWidth: 0 },
    renderedArtifactContent: {
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
      wordBreak: 'normal',
      // cells wrap instead of being clipped, so an ordinary table never needs
      // to scroll; the scroll container stays for a genuinely wide one. Column
      // widths are left to auto layout — no fixed proportion is imposed.
      '& table': {
        display: 'block',
        maxWidth: '100%',
        overflowX: 'auto',
        borderCollapse: 'collapse',
      },
      '& th, & td': {
        textAlign: 'left',
        verticalAlign: 'top',
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
        padding: theme.spacing(0.75, 2, 0.75, 0),
        borderBottom: `1px solid ${theme.palette.divider}`,
      },
    },
    sourceContent: {
      maxWidth: '100%',
      margin: 0,
      overflowX: 'auto',
      whiteSpace: 'pre',
      overflowWrap: 'normal',
      wordBreak: 'normal',
    },
  });

const readerControlStyles = (theme: Theme) =>
  createStyles({
    contentActions: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    live: {
      position: 'absolute',
      width: 1,
      height: 1,
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)',
    },
  });

export const readerStyles = (theme: Theme) =>
  createStyles({
    shellLayout: { display: 'grid', gap: theme.spacing(3) },
    ...readerStyles_(theme),
    ...readerControlStyles(theme),
    '@media (prefers-reduced-motion: reduce)': {
      segment: { transition: 'none' },
      node: { transition: 'none' },
    },
  });
